export default __webpack_public_path__ + "static/media/arrow-top.536b7cf1.svg";